"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferStatus = exports.StripeAvailablePaymentMethod = exports.ChargeType = exports.StripeRecurringInterval = exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    /**
     * @type {string}
     * @deprecated.
     */
    PaymentMethod["Transfer"] = "transfer";
    /**
     * @type {string}
     * @deprecated.
     */
    PaymentMethod["Unknown"] = "unknown";
    /**
     * @type {string}
     * @deprecated.
     */
    PaymentMethod["Manual"] = "manual";
    PaymentMethod["Free"] = "free";
    PaymentMethod["Card"] = "card";
    PaymentMethod["Cheque"] = "cheque";
    PaymentMethod["Daf"] = "daf";
    PaymentMethod["Pad"] = "pad";
    PaymentMethod["Ach"] = "ach";
    PaymentMethod["Sepa"] = "sepa";
    PaymentMethod["ApplePayOrGooglePay"] = "applePayOrGooglePay";
    PaymentMethod["Cash"] = "cash";
    PaymentMethod["InKind"] = "inKind";
    /**
     * @type {string}
     * @deprecated.
     */
    PaymentMethod["Stocks"] = "stocks";
    PaymentMethod["Other"] = "other";
    PaymentMethod["TapToPay"] = "tapToPay";
    PaymentMethod["CashApp"] = "cashApp";
    PaymentMethod["PayPal"] = "paypal";
    PaymentMethod["Venmo"] = "venmo";
    PaymentMethod["Pledge"] = "pledge";
    PaymentMethod["Invoice"] = "invoice";
    PaymentMethod["InPersonCash"] = "inPersonCash";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var StripeRecurringInterval;
(function (StripeRecurringInterval) {
    StripeRecurringInterval["day"] = "day";
    StripeRecurringInterval["week"] = "week";
    StripeRecurringInterval["biWeek"] = "biWeek";
    StripeRecurringInterval["month"] = "month";
    StripeRecurringInterval["quarter"] = "quarter";
    StripeRecurringInterval["year"] = "year";
})(StripeRecurringInterval || (exports.StripeRecurringInterval = StripeRecurringInterval = {}));
var ChargeType;
(function (ChargeType) {
    ChargeType["Donation"] = "Donation";
    ChargeType["Ticket"] = "Ticket";
    ChargeType["DebitConnectedAccount"] = "DebitConnectedAccount";
})(ChargeType || (exports.ChargeType = ChargeType = {}));
var StripeAvailablePaymentMethod;
(function (StripeAvailablePaymentMethod) {
    StripeAvailablePaymentMethod["Card"] = "card";
    StripeAvailablePaymentMethod["Pad"] = "acss_debit";
    StripeAvailablePaymentMethod["Ach"] = "us_bank_account";
    StripeAvailablePaymentMethod["Sepa"] = "sepa_debit";
    StripeAvailablePaymentMethod["CashApp"] = "cashapp";
})(StripeAvailablePaymentMethod || (exports.StripeAvailablePaymentMethod = StripeAvailablePaymentMethod = {}));
var TransferStatus;
(function (TransferStatus) {
    TransferStatus["DoesNotApply"] = "does_not_apply";
    TransferStatus["Pending"] = "pending";
    TransferStatus["Initiated"] = "initiated";
    TransferStatus["Done"] = "done";
    TransferStatus["Failed"] = "failed";
})(TransferStatus || (exports.TransferStatus = TransferStatus = {}));
